import { render, staticRenderFns } from "./restore_captain.vue?vue&type=template&id=331c414e&scoped=true&"
import script from "./restore_captain.vue?vue&type=script&lang=js&"
export * from "./restore_captain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c414e",
  null
  
)

export default component.exports